import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useContextMenuClose } from "../../../hooks/useContextMenuClose";

export default function ContextMenu({
    menu,
    setMenu,
    selected,            // Set of "type:id"
    clearSelection,
    openMoveDialog,
    openDeleteConfirm,
    onRename,            // (ids: string[] | string) => Promise<void>
}) {
    const menuRef = useRef(null);

    const { menuProps } = useContextMenuClose({
        ref: menuRef,
        open: !!(menu && menu.open),
        onClose: () => {
            setMenu(null);
            clearSelection();
        },
        closeOnScroll: true,
        closeOnResize: true,
        closeOnBlur: true,
        autoCloseMs: 5000,
        pauseOnHover: true,
    });

    if (!menu?.open) return null;

    const selectedIds = Array.from(selected || []).map((k) => String(k).split(":")[1]);

    const handleRename = async (anchor) => {
        setMenu(null);
        if (!selectedIds.length) return;
        // для одиничного перейменування передаємо один id,
        // для групового — масив (батько сам вирішить, що робити)

        await onRename?.(selectedIds.length === 1 ? selectedIds[0] : selectedIds, anchor);
    };

    return (
        <div
            ref={menuRef}
            role="menu"
            className="fixed z-50 w-48 overflow-hidden rounded-xl border bg-white shadow-2xl"
            style={{ top: menu.y + 2, left: menu.x + 2 }}
            {...menuProps}
        >
            <div className="px-3 py-2 text-xs text-gray-500">Дій для: {selected.size}</div>

            <button
                role="menuitem"
                onClick={() => {
                    setMenu(null);
                    openMoveDialog();
                }}
                className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-gray-50"
            >
                📦 Перемістити…
            </button>

            <button
                role="menuitem"
                onClick={(e) => {
                    // координати саме цього пункту
                    const r = e.currentTarget.getBoundingClientRect();
                    const anchor = { x: r.right + 8, y: r.top }; // “поруч і на рівні”
                    handleRename?.(anchor);
                }}
                className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm hover:bg-gray-50"
            >
                ✏️ Перейменувати
            </button>

            <button
                role="menuitem"
                onClick={() => {
                    setMenu(null);
                    openDeleteConfirm();
                }}
                className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-red-600 hover:bg-red-50"
            >
                🗑️ Видалити
            </button>
        </div>
    );
}

ContextMenu.propTypes = {
    menu: PropTypes.shape({
        open: PropTypes.bool,
        x: PropTypes.number,
        y: PropTypes.number,
    }),
    setMenu: PropTypes.func.isRequired,
    selected: PropTypes.instanceOf(Set).isRequired,
    clearSelection: PropTypes.func.isRequired,
    openMoveDialog: PropTypes.func.isRequired,
    openDeleteConfirm: PropTypes.func.isRequired,
    onRename: PropTypes.func.isRequired,
};

ContextMenu.defaultProps = {
    menu: null,
};
